module.exports = __webpack_public_path__ + "static/media/home_16.8f39f451.jpg";